import "./wave-animation.css";

export const WaveAnimation = () => {
  return (
    <div className="h-24 flex p-4">
      <div className="flex items-end content-center">
        {Array.from(Array(8).keys()).map((key) => {
          return <div key={key} className="bg-white bar w-1.5 mx-0.5" />;
        })}
      </div>
    </div>
  );
};
